<mat-form-field [ngClass]="datePickerClass">
  <input
    class="datePickerInput"
    matInput
    [matDatepicker]="picker"
    [formControl]="dateControl"
    [placeholder]="placeholderLevel"
    mask="00/00/0000"
    [max]="maxDate"
  />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
